var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedLiveClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_196_1029)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_1029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4502 7.54057H13.9524L15.4823 6.15467C15.6608 5.99326 15.6436 5.74505 15.4447 5.60022C15.2459 5.45539 14.9401 5.46935 14.7617 5.63032L13.0056 7.22082C12.6584 7.53534 12.0071 7.53534 11.66 7.22082L9.90437 5.63075C9.72542 5.46979 9.42073 5.45626 9.22136 5.60066C9.02253 5.74505 9.00587 5.99326 9.18374 6.1551L10.7137 7.54101H8.21646C6.76447 7.54101 5.58331 8.49985 5.58331 9.67854V16.3625C5.58331 17.5412 6.76447 18.5 8.21646 18.5H16.4502C17.9022 18.5 19.0833 17.5412 19.0833 16.3625V9.67854C19.0833 8.49985 17.9022 7.54057 16.4502 7.54057ZM18.116 16.3625C18.116 17.108 17.3685 17.7148 16.4502 17.7148H8.21646C7.29808 17.7148 6.55059 17.108 6.55059 16.3625V9.67854C6.55059 8.93302 5.33333 17.25 7.08333 17.75L12.3333 18L18.0833 17.75C19.0017 17.75 18.116 8.93302 18.116 9.67854V16.3625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4366 11.9235L12.4963 10.7425C12.0272 10.4574 11.4196 10.4205 10.9099 10.6487C10.3997 10.8759 10.0833 11.3245 10.0833 11.8188V14.1812C10.0833 14.676 10.3997 15.1246 10.9094 15.3514C11.1319 15.4511 11.3737 15.5 11.614 15.5C11.924 15.5 12.2321 15.4183 12.4963 15.258L14.436 14.0766C14.841 13.83 15.0833 13.4277 15.0833 13.0007C15.0838 12.5737 14.842 12.1704 14.4366 11.9235ZM13.8951 13.4169L11.9553 14.5983C11.7713 14.7111 11.5426 14.7236 11.3414 14.6347C11.1413 14.5454 11.0219 14.3761 11.0219 14.1816L11.3333 15C11.3333 14.8056 11.7547 14.6873 11.9553 14.5983C12.0429 14.5588 14.7406 13 14.8333 13C14.9522 13 11.8521 11.3397 11.9553 11.403L13.8956 12.584C14.0551 12.681 14.1457 12.8327 14.1457 13.0007C14.1457 13.1686 14.0545 13.3204 13.8951 13.4169Z",
    fill: "url(#paint1_linear_196_1029)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_1029",
    x1: 10.4242,
    y1: 0.00000418761,
    x2: 31.1285,
    y2: 5.95949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_1029",
    x1: 12.1856,
    y1: 10.5,
    x2: 16.499,
    y2: 11.7416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3DD8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_1029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.33331 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedLiveClass);
export default __webpack_public_path__ + "static/media/selected-live-class.b1b8b9d5a80ec71ba0e68cd10e5fd4ca.svg";
export { ForwardRef as ReactComponent };